import { atom, PrimitiveAtom } from 'jotai';
import { Store } from 'jotai/vanilla/store';
import { ApiError } from '@/helpers/baseApi';

interface QueryState<T> {
  data: T | null,
  error?: ApiError,
  isLoading: boolean,
};

const familyMapAtom = atom(new Map<string, any>());

export const queryAtomFamily = (path: string, store: Store) => {
  const familyMap = store.get(familyMapAtom);

  if (!familyMap.has(path)) {
    const newAtom = atom<QueryState<any>>({
      data: null,
      error: undefined,
      isLoading: false,
    });
    familyMap.set(path, newAtom);
    store.set(familyMapAtom, familyMap);
  }

  return familyMap.get(path) as PrimitiveAtom<QueryState<any>>;
};

export const safeKey = (key: any) => key ? key.toString().replaceAll('-', '_') : '_';

export const objectToKey = (obj: Record<string, any>) => {
  return Object.keys(obj).sort().map(key => `${safeKey(key)}:${safeKey(obj[key])}`).join('-');
};

export const clearQueryBranch = (prefix: string, store: Store) => {
  const familyMap = store.get(familyMapAtom);

  for (const [key, atomInstance] of familyMap.entries()) {
    if (key === prefix || key.startsWith(prefix + '-')) {
      store.set(atomInstance, {
        data: null,
        error: undefined,
        isLoading: false,
      });
    }
  }
};
